import { useQuery } from "@tanstack/react-query"
import { queries } from "../../queries"

export const useChannelsQuery = () => {
  return useQuery(queries.channels.list())
}
